<template>
  <div>
    <div class="bg-blue-900 p-4 sm:p-12">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Pipelines
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4">
            <NewPipeline />
          </div>
        </div>
      </div>
    </div>

    <div class="sm:p-12">
      <div class="max-w-7xl mx-auto">
        <div v-if="rejected" class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg
                class="h-5 w-5 text-red-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414
                  1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293
                  1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0
                  00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                Something went wrong. Please try again.
              </h3>
            </div>
          </div>
        </div>

        <div v-else class="bg-white shadow overflow-hidden sm:rounded-md">
          <ul class="divide-y divide-gray-200">
            <PipelineListLine
              v-for="pipeline in pipelines"
              :key="pipeline.id"
              :pipeline="pipeline"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewPipeline from './components/NewPipeline.vue';
import PipelineListLine from './components/PipelineListLine.vue';

function data() {
  return {
    rejected: false,
  };
}

const computed = {
  pipelines() {
    const {
      state: { entities, admin },
    } = this.$store;

    return admin.pipelines.ids.map((id) => entities.pipelines.byId[id]);
  },
};

const methods = {
  setRejected(value) {
    this.rejected = Boolean(value);
  },
  async fetchPipelines() {
    try {
      await this.$store.dispatch('admin/pipelines/load', {
        params: {
          include: 'pipelineStages',
          per_page: 100,
        },
      });
    } catch (error) {
      this.setRejected(true);
    }
  },
};

function created() {
  this.fetchPipelines();
}

function destroyed() {
  const { commit } = this.$store;

  commit('admin/pipelines/setIds', []);
  commit('admin/pipelines/setMeta', null);
  commit('admin/pipelines/setLinks', null);
}

export default {
  components: { PipelineListLine, NewPipeline },
  data,
  computed,
  methods,
  created,
  destroyed,
};
</script>
